<template>
    <div class="mx-2 mx-lg-5">
        <div class="row mt-3">
            <div class="col-12 col-md-6">
                <div class="card mt-3">
                    <div class="card-header">
                        {{ $t("headers.vehicleNfcDetail") }}
                    </div>
                    <div class="card-body">
                        <dl class="row mb-0">
                            <dt class="col-sm-4">{{ $t("vehicleNfcEntry.licencePlate") }}</dt>
                            <dd class="col-sm-8">{{ entry.licence_plate_snapshot || "—" }}</dd>

                            <dt class="col-sm-4">{{ $t("vehicleNfcEntry.name") }}</dt>
                            <dd class="col-sm-8">{{ entry.name_snapshot || "—" }}</dd>

                            <dt class="col-sm-4">{{ $t("vehicleNfcEntry.arrived") }}</dt>
                            <dd class="col-sm-8">
                                <span v-if="entry.arrived_at">
                                    {{ $d(new Date(entry.arrived_at), 'short') }}
                                </span>
                                <span v-else>—</span>
                            </dd>

                            <dt class="col-sm-4">{{ $t("vehicleNfcEntry.left") }}</dt>
                            <dd class="col-sm-8">
                                <span v-if="entry.left_at">
                                    {{ $d(new Date(entry.left_at), 'short') }}
                                </span>
                                <span v-else>—</span>
                            </dd>
                        </dl>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 mt-3 mt-md-0">
                <div class="card mt-3">
                    <div class="card-header">
                        {{ $t("headers.vehicleNfcInfo") }}
                    </div>
                    <div class="card-body">
                        <dl class="row mb-0">
                            <dt class="col-sm-4">{{ $t("vehicleNfcEntry.noteArrived") }}</dt>
                            <dd class="col-sm-8">{{ entry.note_arrived || "—" }}</dd>

                            <dt class="col-sm-4">{{ $t("vehicleNfcEntry.noteLeft") }}</dt>
                            <dd class="col-sm-8">{{ entry.note_left || "—" }}</dd>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        {{ $t("vehicleNfcEntry.photos") }}
                    </div>
                    <div class="card-body">
                        <div class="d-flex flex-wrap justify-content-center align-items-center gap-2 my-3">
                            <input type="file" ref="fileInput" style="display: none;" accept="image/png, image/jpg"
                                @change="addPhoto" />
                            <div class="d-flex flex-column align-items-center gap-3">
                                <button v-if="$store.getters.hasGatehousePerm('add_vehiclenfcentryphoto')"
                                    class="btn btn-primary p-3" @click="$refs.fileInput.click()"
                                    style="width: 200px; height: 150px;">
                                    <icon icon="CameraPlus"></icon>
                                </button>
                                <div v-if="!photos.length" class="text-muted text-center fs-4 fw-bold">
                                    {{ $t("vehicleNfcEntry.noPhoto") }}
                                </div>
                            </div>
                            <div class="d-flex flex-column align-items-center gap-2" v-for="photo in photos"
                                :key="photo.id" style="cursor: pointer; width: 200px;">
                                <img class="img_min" :src="getPhotoUrl(photo.id, true)" @click="openModal(photo.id)" />
                                <button v-if="$store.getters.hasGatehousePerm('delete_vehiclenfcentryphoto')"
                                    class="btn btn-sm btn-danger" @click="deletePhoto(photo.id)">
                                    {{ $t("utils.delete") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="photoModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content modal_wrapper">
                <div class="modal-header justify-content-between align-items-center border-0 mx-4">
                    <h3 class="modal-title">Fotky</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body mx-auto">
                    <button
                        class="btn btn-primary position-absolute top-50 start-0 translate-middle-y px-3 py-4 fs-4"
                        @click="prevPhoto"
                    >
                        <
                    </button>
                    <img :src="getPhotoUrl(currentPhotoId)" class="img-fluid" />
                    <button
                        class="btn btn-primary position-absolute top-50 end-0 translate-middle-y px-3 py-4 fs-4"
                        @click="nextPhoto"
                    >
                        >
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import { CONFIG } from "@/config.js"
import { Modal } from "bootstrap/dist/js/bootstrap.bundle.min.js";

export default {
    components: {
        Icon,
    },
    data() {
        return {
            entry: {},
            currentPhotoId: null,
            currentIndex: 0,
        }
    },
    created() {
        this.getEntry();
    },
    methods: {
        getEntry() {
            this.$store.getters.api.get(`/${this.$route.params.slug}/vehicle-nfc/entries/${this.$route.params.id}`)
                .then(response => {
                    this.entry = response.data;
                })
                .catch(error => {
                    console.error("Error loading vehicle NFC entry", error);
                });
        },
        addPhoto(event) {
            const file = event.target.files[0];
            if (!file) return;

            const entryId = this.entry.id;
            const fileName = `${entryId}_${file.name}`;

            const formData = new FormData();
            formData.append("file", file, fileName);

            this.$store.getters.api.post(`/${this.$route.params.slug}/vehicle-nfc/entries/${entryId}/photos`, formData)
                .then(() => {
                    this.getEntry();
                })
                .catch(error => {
                    console.error("Error adding photo.", error);
                });
        },
        getPhotoUrl(photoId, thumb = false) {
            var url = CONFIG.api.baseUrl;
            url += `/${this.$route.params.slug}/vehicle-nfc/entries/${this.entry.id}/photos/${photoId}`
            if (thumb) {
                url += "?thumb=true";
            }
            return url
        },
        deletePhoto(photoId) {
            const confirm = window.confirm("Opravdu chcete smazat fotku?");
            if (!confirm) return;

            this.$store.getters.api.delete(`/${this.$route.params.slug}/vehicle-nfc/entries/${this.entry.id}/photos/${photoId}/delete`)
                .then(() => {
                    this.getEntry();
                })
                .catch(error => {
                    console.error("Error deleting photo.", error);
                });
        },
        openModal(photoId) {
            const index = this.photos.findIndex(p => p.id === photoId);
            if (index !== -1) {
                this.currentIndex = index;
                this.currentPhotoId = photoId;

                const modal = new Modal(document.getElementById('photoModal'));
                modal.show();
            }
        },
        nextPhoto() {
            this.currentIndex = (this.currentIndex + 1) % this.photos.length;
            this.currentPhotoId = this.photos[this.currentIndex].id;
        },
        prevPhoto() {
            this.currentIndex = (this.currentIndex - 1 + this.photos.length) % this.photos.length;
            this.currentPhotoId = this.photos[this.currentIndex].id;
        },
    },
    computed: {
        photos() {
            return this.entry.photos || [];
        },
    }
}
</script>
